<template>
  <transition name="el-fade-in-linear">
  <div v-show="transitionshow">
    
    <el-form :inline="true" class="backborder1 demo-form-inline" size="small">
        <el-form-item>
    		<el-select v-model="query.type" @change="query.ischange=true">
			    <el-option v-for="(item,index) in typelists" :label="item.name" :value="item.id" :key="index"></el-option>
			</el-select>
    	</el-form-item>
        <el-form-item>
    		<el-select v-model="query.typesecond" @change="query.ischange=true">
			    <el-option v-for="(item,index) in secontypelists" :label="item.name" :value="item.id" :key="index"></el-option>
			</el-select>
    	</el-form-item>
        <el-form-item>
    		<el-input placeholder="物流单号 / 销售单号 / 商城订单号" v-model="query.key" clearable @change="query.ischange=true"  @keyup.enter.native.prevent="getlists" />
    	</el-form-item>
        <el-form-item>
    		<el-button type="primary" size="mini" icon="el-icon-search" circle @click="getlists"></el-button>
    	</el-form-item>
    </el-form>

    <!-- 物流信息详情 -->
    <div class="backborder2" style="margin-top:10px;float:left;width:98%" v-loading="query.loading">
        <div class="packstyle" v-if="lists.length>0">
            <div style="float:left;width:100%">
              <a v-for="(tt,ii) in lists" :style="tt.isactive==1 ? 'float:left;padding:5px 20px;border-bottom:2px solid #e6a23c;font-size:13px;cursor:pointer' : 'float:left;padding:5px 20px;border-bottom:2px solid #fff;font-size:13px;cursor:pointer' " @click="checkpacklogistics(ii)">{{tt.shippingname}}（单号：{{tt.code}}）</a>
            </div>
            <div v-for="(tt,ii) in lists" v-if="tt.isactive==1">
                <div class="shippingreciever" style="border-bottom:none">
                  <span>收货人：{{tt.name}}（{{tt.phone}}），收货人地址：{{tt.city}}，详细地址：{{tt.address}}</span>
                </div>
                <div style="float:left;margin-left:2%;margin-top:20px;font-size:14px;color:#999999" v-if="tt.data.length==0">
                  当前物流信息尚未更新，请耐心等待
                </div>
                <ul style="padding:0 2%;margin-top:30px;float:left;width:96%">
                    <li v-for="(ttt,iii) in tt.data" style="border-left:2px solid #e4e7ed;" v-if="ttt.isend=='no'">
                      <div class="icon" v-if="iii == 0" style="position:relative"><span style="float:left;width:.8rem;height:.8rem;border-radius:50%;background:red;border:.2rem solid #ddd"></span></div>
                      <div class="time" v-if="iii == 0" style="color:red;margin-top:-1.3rem">{{ttt.content}}</div>
                      <span class="content" v-if="iii == 0" style="color:red">{{ttt.msgTime}}</span>
                      <span class="content" v-if="iii == 0 && tt.operator!=''" style="color:red">操作人：{{ttt.operator}}</span>

                      <div class="icon" v-if="iii > 0" style="position:relative"><img src="../../assets/time.png" /></div>
                      <div class="time" v-if="iii > 0" style="margin-top:-1.3rem">{{ttt.content}}</div>
                      <span class="content" v-if="iii > 0">{{ttt.msgTime}}</span>
                      <span class="content" v-if="iii > 0 && ttt.operator!=''">操作人：{{tt.operator}}</span>
                    </li>
                    <li v-for="(ttt,iii) in tt.data" v-if="ttt.isend=='yes'">
                      <div class="icon" v-if="iii == 0" style="color:red;position:relative"><span style="float:left;width:.8rem;height:.8rem;border-radius:50%;background:red;border:.2rem solid #ddd"></span></div>
                      <div class="time" v-if="iii == 0" style="color:red;margin-top:-1.3rem">{{ttt.content}}</div>
                      <span class="content" v-if="iii == 0" style="color:red">{{ttt.msgTime}}</span>
                      <span class="content" v-if="iii == 0 && tt.operator!=''" style="color:red">操作人：{{ttt.operator}}</span>

                      <div class="icon" v-if="iii > 0" style="position:relative"><img src="../../assets/time.png" /></div>
                      <div class="time" v-if="iii > 0" style="margin-top:-1.3rem">{{ttt.content}}</div>
                      <span class="content" v-if="iii > 0">{{ttt.msgTime}}</span>
                      <span class="content" v-if="iii > 0 && ttt.operator!=''">操作人：{{ttt.operator}}</span>
                    </li>
                </ul>
            </div>
        </div>
    </div>

  </div>
  </transition>
</template>

<script>
import QRCode from 'qrcodejs2'
export default {
  props:['childdata'],
  components: {QRCode},
  data () {
    return {
      url:this.GLOBAL.domain+"Sellshippingbirld/index",
      transitionshow:true,
      actionauth:[],
      query: {
          act:'checkshippings',
          token:this.$cookies.get('token'),
          loading:false,
          ischange:false,
          type:1,
          typesecond:2,
          key:'',
      },
      typelists:[
          {id:1,name:'按快递单号查询'},
          {id:2,name:'按销售单号查询'},
          {id:3,name:'按商城订单号查询'},
          {id:4,name:'按打印电子面单号查询'},
      ],
      secontypelists:[
          {id:1,name:'按单号所属 id 查询'},
          {id:2,name:'按单号查询'},
      ],
      lists:[],

    }  
  },

  watch: {
    childdata(val) {
        if(val.checkshippingsid > 0) {
              if(val.checkshippingtype==1 && val.checkshippingsid > 0) { //按物流单号查询
                  this.query.type=1;
                  this.query.typesecond=1,
                  this.query.key=val.checkshippingsid;
                  this.getlists();
              }else if(val.checkshippingtype==2 && val.checkshippingsid > 0) { //按销售单号查询
                  this.query.type=2;
                  this.query.typesecond=1,
                  this.query.key=val.checkshippingsid;
                  this.getlists();
              }else if(val.checkshippingtype==3 && val.checkshippingsid > 0) { //按商城订单号查询
                  this.query.type=3;
                  this.query.typesecond=1,
                  this.query.key=val.checkshippingsid;
                  this.getlists();
              }else if(val.checkshippingtype==4 && val.checkshippingsid > 0) { //按打印单查询
                  this.query.type=4;
                  this.query.typesecond=1,
                  this.query.key=val.checkshippingsid;
                  this.getlists();
              }
        }

    }

  },
  
  
  mounted(){
      this.getactionauth(); //获取权限设置

      if(this.childdata.checkshippingtype==1 && this.childdata.checkshippingsid > 0) { //按物流单号查询
          this.query.type=1;
          this.query.typesecond=1,
          this.query.key=this.childdata.checkshippingsid;
          this.getlists();
      }else if(this.childdata.checkshippingtype==2 && this.childdata.checkshippingsid > 0) { //按销售单号查询
          this.query.type=2;
          this.query.typesecond=1,
          this.query.key=this.childdata.checkshippingsid;
          this.getlists();
      }else if(this.childdata.checkshippingtype==3 && this.childdata.checkshippingsid > 0) { //按商城订单号查询
          this.query.type=3;
          this.query.typesecond=1,
          this.query.key=this.childdata.checkshippingsid;
          this.getlists();
      }else if(this.childdata.checkshippingtype==4 && this.childdata.checkshippingsid > 0) { //按打印单号查询
          this.query.type=4;
          this.query.typesecond=1,
          this.query.key=this.childdata.checkshippingsid;
          this.getlists();
      }else { //正常空置查询
          this.getlists();
      }

  },
  
  
  methods:{
    
    /** 获取操作功能权限 **/
  	getactionauth() {
    	var data =this.$cookies.get('actionauth');
    	data=JSON.parse(data);
        this.actionauth=data;
    },

    /** 查询物流信息 **/
    getlists() {
        this.query.loading=true;
        var resource = this.$resource(this.url);
        resource.save(this.query).then((res) => {
          if(res.data.Result>0){
            if(res.data.Result=='70001') this.$router.push('/login')
            this.$message.error(res.data.Message);
            this.query.loading=false;
          }else{
            this.lists=JSON.parse(Base64.decode(res.data.Data));
            this.query.loading=false;
          }
        }).catch((res) => {
          this.query.loading=false;
        });
    },


    //切换选择包裹物流单号信息
		checkpacklogistics(ii) {
			var logistics=this.lists;
			logistics.forEach(function(e,i) {
				ii==i ? e.isactive=1 : e.isactive=0;
			});
		},

    
  }
}
</script>

</script>
<style type="text/css">
.backborder1 {background:#fff;border-radius:15px;border:1px solid #ddd;padding:1% 1% 0 1%}
.backborder2 {background:#fff;border-radius:15px;border:1px solid #ddd;padding:1% 1% 3% 1%}

.packstyle {float:left;margin-top:10px;background:#fff;border-radius:5px;padding:1rem 2% 1rem 2%;width:96%}
.packstyle li {padding:0 5% 1rem 0;float:left;width:100%;list-style-type:none}
.packstyle .icon {width:1.2rem;height:1.2rem;border-radius:50%;position:absolute;margin-left:-.65rem;margin-top:0}
.packstyle .icon img {width:100%;background:#fff}
.packstyle .time {float:left;margin-left:3%;margin-top:-.1rem;color:#303133;font-size:.7rem;line-height:1.5rem}
.packstyle .content {float:left;width:90%;margin-left:3%;color:#909399;font-size:.7rem;line-height:1.5rem}
.shippingreciever {float:left;width:98%;margin-left:2%;margin-top:20px}
.shippingreciever span {float:left;width:100%;font-size:12px;line-height:23px;}
</style>


// WEBPACK FOOTER //
// src/components/home/checkshippings.vue